<template>
  <v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

    <v-card class="form-container" flat style="margin-top:-10px">
      <v-sheet color="transparent" style="text-align:center;padding-top:25px">
                            <v-avatar :size="80" style="background-image: linear-gradient(-180deg, #9e9e9e, #ffff);background-size;border: 1px solid;border-color:black">
                                
                             <img v-if="form.src==null" class="center"
                               src="../../assets/person.jpg" style="cursor:pointer"
                             >
                             <img v-if="form.src!=null"
                               :src=form.src style="cursor:pointer"
                             >
                        </v-avatar>
                        </v-sheet>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm12 md7 style="padding-bottom:10px">
            <v-switch v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
          </v-flex>
          <v-flex xs12 sm12 md5 style="padding-bottom:10px;text-align:right">
            <span style="color:grey;">Password&nbsp;:&nbsp;{{form.passwords}}</span>
          </v-flex>
            <v-flex xs12 sm12 md4 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.fullName" label="Full Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4 style="padding-right:5px">
                <v-text-field disabled v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-text-field :disabled="edit === false" v-model="form.email" label="Email Id *" :rules="[rules.email]" required></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field :disabled="edit === false" v-model="form.address" label="Address"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.nearLocation" label="Near Location"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
                <v-text-field :disabled="edit === false" v-model="form.street" label="Street"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.city" label="City"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.country" label="Country"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field :disabled="edit === false" type="Number" v-model="form.zipCode" label="Zipcode" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 >
                <v-autocomplete
                 :disabled="edit === false"
              v-model="selectedState"
              :items="states"
              color="primary"
              label="Select State *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm12 md6 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.gstNumber" label="GST Number"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
                <v-text-field :disabled="edit === false" v-model="form.panNumber" label="PAN Number"></v-text-field>
            </v-flex>
          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn :disabled="edit === false" depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      edit: false,
      title: "Create Counselling",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Customer",
          disabled: false,
          to: "/customer"
        },
        {
          text: "Edit",
          disabled: true,
          to: "/createStudent"
        }
      ],
      form: {
          fullName: null,
          mobileNumber: null,
          email: null,
          address: '',
          street: '',
          city: '',
          country: '',
          nearLocation: '',
          zipCode: null,
      },
      selectedState: 1,
      states: []
    };
  },

  mounted() {
    this.axios
      .get(config.API + `Customers/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.selectedState = res.data.stateCode;
      });
      this.axios
        .get(config.API + `States`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
          this.$Progress.finish();
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Customers/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),
              fullName: this.form.fullName,
              email: this.form.email,
              address: this.form.address,
              nearLocation: this.form.nearLocation,
              city: this.form.city,
              country: this.form.country,
              street: this.form.street,
              stateCode: JSON.parse(this.selectedState),
              zipCode: JSON.parse(this.form.zipCode),
              gstNumber: this.form.gstNumber,
              panNumber: this.form.panNumber,
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            //this.$router.push(`counsellingImage/${code}`);
            this.$router.go(-1);
          })
          .catch(err => {
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
